import script from "./WhatsppLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsppLayout.vue?vue&type=script&setup=true&lang=js"

import "./WhatsppLayout.vue?vue&type=style&index=0&id=62e49af0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e49af0"]])

export default __exports__